import type { ProgramAccountTierEntity } from "../ProgramAccount/entities/RewardsProgramAccountEntity";
import type { VipTierEntity } from "./entities/RewardsVipTiersEntities";

export const getCustomerTierIndex = (
    tierList: VipTierEntity[],
    customerTier: ProgramAccountTierEntity | null
) => tierList.findIndex((tier) => tier.id === customerTier?.id);

export const isCustomerTier = (
    tier: VipTierEntity,
    customerTier: ProgramAccountTierEntity | null
): boolean => tier.id === customerTier?.id;
